import Vue from 'vue'

Vue.directive('has', {
    inserted: function(el, binding ,vnode) {
        let nodes=el
        // console.log( "---", vnode.context.$route );
        //得到该页面的按钮权限
        sessionStorage.setItem('has',vnode.context.$route.meta.btnpermissions)
        if (!Vue.prototype.$_has(binding.value)) {
            //移除元素
            if(binding.value== "btn_status")return
                el.parentNode.removeChild(el)
            //display样式none
            // let className=el.getAttribute("class")
            // el.setAttribute("class","hidden")
        }
    }
})
// 权限检查方法（且把该方法添加到vue原型中）
Vue.prototype.$_has = function(value) {
    let isExist = false
    // 从浏览器缓存中获取权限数组（该数组在登入成功后拉取用户的权限信息时保存在浏览器的缓存中）
    var buttonpermsStr = sessionStorage.getItem('has')
    if (buttonpermsStr === undefined || buttonpermsStr == null) {
        return true
    }
    if (buttonpermsStr.indexOf(value) >= 0) {
        // 若在按钮中定义的权限字段能在后端返回的权限数组中能找到，则该按钮可显示
        isExist = true
    }
    return isExist
}

Vue.prototype.$_hasAll = function(value) {
    let isExist = true
    // 从浏览器缓存中获取权限数组（该数组在登入成功后拉取用户的权限信息时保存在浏览器的缓存中）
    var buttonpermsStr = sessionStorage.getItem('hasAll')
    if (buttonpermsStr === undefined || buttonpermsStr == null) {
        return false
    }
    value.map((item,index)=>{
        if (buttonpermsStr.indexOf(item) >= 0) {
            // 若在按钮中定义的权限字段能在后端返回的权限数组中能找到，则该按钮可显示
            isExist = false
        }
    })
    return isExist
}


const debounce = {
    inserted: function (el, binding) {
        let timer
        el.addEventListener('keyup', () => {
            if (timer) {
                clearTimeout(timer)
            }
            timer = setTimeout(() => {
                binding.value()
            }, 1000)
        })
    },
}




Vue.directive('clickoutside', {
    bind(el, binding, vnode) {
        function documentHandler(e) {
            // 这里判断点击的元素是否是本身，是本身，则返回
            if (el.contains(e.target)) {
            // 判断指令中是否绑定了函数
            if (binding.expression) {
                // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
                binding.value(e);
            }
            }
        }
        // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
        el.__vueClickOutside__ = documentHandler;
        document.addEventListener('click', documentHandler);
    },
    // inserted: function(el, binding ,vnode) {
    //     let nodes=el
    //     //得到该页面的按钮权限
    //     sessionStorage.setItem('has',vnode.context.$route.meta.btnpermissions)
    //     if (!Vue.prototype.$_has(binding.value)) {
    //         //移除元素
    //         if(binding.value== "btn_status")return
    //         el.parentNode.removeChild(el)
    //         //display样式none
    //         // let className=el.getAttribute("class")
    //         // el.setAttribute("class","hidden")
    //     }
    // }
})

// clickoutside: { // 初始化指令
//     bind(el, binding, vnode) {
//         function documentHandler(e) {
//             // 这里判断点击的元素是否是本身，是本身，则返回
//             if (el.contains(e.target)) {
//                 return false;
//             }
//             // 判断指令中是否绑定了函数
//             if (binding.expression) {
//                 // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
//                 binding.value(e);
//             }
//         }
//         // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
//         el.__vueClickOutside__ = documentHandler;
//         document.addEventListener('click', documentHandler);
//     },
//     update() {},
//     unbind(el, binding) { // 解除事件监听
//         document.removeEventListener('click', el.__vueClickOutside__);
//         delete el.__vueClickOutside__;
//     }
// }


// 按钮短时间内多次点击
// const debounce = {
//     inserted: function (el, binding) {
//         let timer
//         el.addEventListener('keyup', () => {
//             if (timer) {
//                 clearTimeout(timer)
//             }
//             timer = setTimeout(() => {
//                 binding.value()
//             }, 1000)
//         })
//     },
// }

// v-debounce="debounceClick"

